export const VISUAL_NO_DATA_MESSAGE = "This visual has no data to display";
